import React from 'react'
import styled from 'styled-components'
export const RegionLabel = ({
  x,
  y,
  data,
}: {
  x: number
  y: number
  data: RegionLabelType
}) => {
  const { r = 20, color = '#D3343F', label } = data

  return (
    <RegionLabelGroup transform={`translate(${x},${y})`}>
      <MarkerBackground rx={r[0]} ry={r[1]} opacity={0.5} />
      <MarkerForeground rx={r[0]} ry={r[1]} color={color} />
      {label && (
        <>
          <LabelBG textAnchor='middle' stroke={color} y={-r[1] - 4}>
            {label}
          </LabelBG>
          <Label textAnchor='middle' y={-r[1] - 4}>
            {label}
          </Label>
        </>
      )}
    </RegionLabelGroup>
  )
}
const Label = styled.text`
  font-weight: 700;
  fill: var(--site-background);
`
const LabelBG = styled.text`
  font-weight: 700;
  stroke-width: 4;
  @media only screen and (max-width: 711px) {
    stroke-width: 3;
  }
`
const MarkerForeground = styled.ellipse<{ color: string }>`
  fill: none;
  stroke: ${({ color }) => color};
  stroke-width: 2;
  @media only screen and (max-width: 711px) {
    stroke-width: 1.5;
  }
  transition: all 0.5s cubic-bezier(0.390, 0.575, 0.565, 1.000);
  animation: fade-scale-in 0.5s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
    @keyframes fade-scale-in {
    0% {
      opacity: 0;
      transform: scale(0);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`
const MarkerBackground = styled.ellipse`
  fill: none;
  stroke: var(--site-background);
  stroke-width: 6;
  @media only screen and (max-width: 711px) {
    stroke-width: 4;
  }
  transition: all 0.5s cubic-bezier(0.390, 0.575, 0.565, 1.000);
  animation: fade-in 0.49s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
`

const RegionLabelGroup = styled.g`
  font-size: 15px;
  font-weight: 400;
  font-family: var(--font-sans-serif);
  fill: #202346;
  /* transition: all 0.5s cubic-bezier(0.390, 0.575, 0.565, 1.000); */


`
